import React from 'react'
import { connect } from 'react-redux'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import FontAwesome from 'react-fontawesome'
import MissionAdvance from '../MissionAdvance'
import { acceptMission } from '../../../../actions'
import RemainingRepeats from '../..//RemainingRepeats'

const styles = {
  description: {
    padding: '10px',
    paddingBottom: '50px',
  },
  experience: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderRight: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  credits: {
    backgroundColor: '#F58A15',
    textAlign: 'center',
    borderLeft: '1px solid gray',
    color: '#fff',
    padding: '10px',
  },
  icons: {
    marginRight: '5px',
    fontSize: '16px',
  },
}

class MissionDetail extends React.Component {

  icon = (icon, text, color) => (
    <Col xs="12" md="4" >
      <FontAwesome style={{ color }} name={icon} />
      { `\t${text}` }
    </Col>
  )

  render() {
    const { credits, experience } = this.props
    return (
      <div>
        <Row>
          <MissionAdvance />
        </Row>
        <Row style={styles.description}>
          <h4>Descripción</h4>
          { this.props.description }
          <br />
          <br />
          <RemainingRepeats {...this.props} />
        </Row>
        <Row>
          <Col xs="6" md="6" style={styles.experience}>
            <FontAwesome style={styles.icons} name="star" />
            {` ${experience}`}
          </Col>
          <Col xs="6" md="6" style={styles.credits}>
            <FontAwesome style={styles.icons} name="diamond" />
            {` ${credits}`}
          </Col>
        </Row>
      </div>
    )
  }
}

MissionDetail.propTypes = {
  credits: React.PropTypes.number,
  experience: React.PropTypes.number,
  description: React.PropTypes.String,
}

const mapStateToProps = state => ({
  ...state.missions.selectedMission,
})

const mapDispatchToProps = dispatch => ({
  acceptMission: id => dispatch(acceptMission(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MissionDetail)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/PreMissionShow/MissionDetail/index.jsx